/**
 * @description 数据配置 dataConfig
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const dataConfigBiz = new Logic()

dataConfigBiz.findSourceByName = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataConfig.findSourceByName,
    data: data
  })
}

dataConfigBiz.findSourceById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataConfig.findSourceById,
    data: data
  })
}

dataConfigBiz.addSource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataConfig.addSource,
    data: data
  })
}

dataConfigBiz.deleteSource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataConfig.deleteSource,
    data: data
  })
}

dataConfigBiz.updateSource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataConfig.updateSource,
    data: data
  })
}

dataConfigBiz.checkTask = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataConfig.checkTask,
    data: data
  })
}

export default dataConfigBiz
